export const increment = () => {
  return {
    type: 'INCREMENT',
  };
};

export const decrement = () => {
  return {
    type: 'DECREMENT',
  };
};

export const setFormData = (lastName) => {
  return {
    type: 'SET_FORM_DATA',
  };
};

export const setFile1Data = (file1Data) => {
  return {
    type: 'SET_FILE1_DATA',
    payload: file1Data,
  };
};

export const setFile2Data = (file2Data) => {
  return {
    type: 'SET_FILE2_DATA',
    payload: file2Data,
  };
};

export const setFileData = (fileData) => {
  return {
    type: 'SET_FILE_DATA',
    payload: fileData,
  };
};

export const clearFileData = () => {
  return {
    type: 'CLEAR_FILE_DATA',
  };
};

export const setHasWorkExperienceRdx = (hasWorkExperienceRdx) => {
  return {
    type: 'SET_HAS_WORK_EXPERIENCE',
    payload: hasWorkExperienceRdx,
  };
};
